import { render, staticRenderFns } from "./lp-opportunities-for-investors.vue?vue&type=template&id=add56116&scoped=true"
import script from "./lp-opportunities-for-investors.vue?vue&type=script&lang=js"
export * from "./lp-opportunities-for-investors.vue?vue&type=script&lang=js"
import style0 from "./lp-opportunities-for-investors.vue?vue&type=style&index=0&id=add56116&prod&scoped=true&lang=css"
import style1 from "./lp-opportunities-for-investors.vue?vue&type=style&index=1&id=add56116&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add56116",
  null
  
)

export default component.exports